module.exports = __webpack_public_path__ + "assets/white-pooledUser-1210af.svg";